export const BASE64 = "data:application/pdf;base64,";
